<template>
	<div class="o-wrap">
		<el-page-header  content="采购列表" />
		<el-table :data="tableData" border>
			<el-table-column prop="title" label="采购标题"></el-table-column>
			<el-table-column prop="num" label="采购数量"></el-table-column>
			<el-table-column prop="yyhy" label="应用行业"></el-table-column>
			<el-table-column prop="diqu" label="供应商地域"></el-table-column>
			<!-- <el-table-column prop="time" label="截止时间"></el-table-column> -->
			<!-- <el-table-column prop="count" label="报价次数"></el-table-column> -->
			<!-- <el-table-column prop="state" label="展示状态">
				<template slot-scope="scope">
					<div  v-if="scope.row.state==3">
						{{scope.row.remark}}
					</div>
					<div  v-else-if="scope.row.state==2">
						待审核
					</div>
					<div    v-else-if="scope.row.state==1">
						正常显示
					</div>
					<div    v-else-if="scope.row.state==0">
						正常显示
					</div>
				</template>
			</el-table-column> -->
			<el-table-column prop="time" label="发布时间"></el-table-column>
			<el-table-column fixed="right" label="操作">
				<template slot-scope="scope">
					<el-button type="text" size="small" @click="handleDel(scope.row)">下架</el-button>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
	import {
		formatDate
	} from '@/assets/js/formatDate.js'
	export default {
		data() {
			return {
				tableData: [],
				datas:[]
			}
		},
		created() {
			this.$axios.post('Myseller-SellerManage-procureList').then(data => {
				data.forEach(item => {
					item.diqu = item.sheng + item.shi
					// item.add_time = this.formatDate(item.add_time)
				})
				this.tableData = data
			})
		},
		methods: {
			formatDate(time) {
				time = time * 1000
				let date = new Date(time)
				return formatDate(date, 'yyyy-MM-dd')
			},
		
			handleDel(row) {
				this.$confirm('确定下架该信息，是否继续？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$axios.post('Myseller-SellerManage-del_caigou', {
						delss: row.id,
						userid:row.userid,
						user_id: this.$store.state.USER_ID,
					}).then(res => {
						if (res.code == 200) {
							this.$message({
								message: '下架成功',
								type: 'success'
							});
							this.tableData.forEach((val, index) => {
								if (val.id == row.id) {
									this.tableData.splice(index, 1);
								}
							})
						}
					})
				}).catch(() => {})
			},
		}
	}
</script>

<style>

</style>
